/* src/app/shared/ui-kit/pa-input-otp/pa-input-otp.component.scss */
:host {
  display: block;
}
.pa-input-otp {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
}
:host ::ng-deep .p-inputotp {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  gap: 8px;
}
:host ::ng-deep .p-inputotp-input.p-inputtext {
  flex: 0 0 48px !important;
  width: 48px !important;
  min-width: 48px !important;
  max-width: 48px !important;
  height: 48px !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  text-align: center !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 48px !important;
  border-radius: 4px !important;
  border: 1px solid var(--secondary-regular-default) !important;
  background: var(--contrast-inverse) !important;
  color: var(--text-default) !important;
  box-shadow: none !important;
  outline: none !important;
  caret-color: var(--text-default);
}
:host ::ng-deep .p-inputotp-input.p-inputtext:enabled:hover {
  border-color: var(--secondary-subtle-active) !important;
}
:host ::ng-deep .p-inputotp-input.p-inputtext:enabled:focus {
  border-color: var(--secondary-subtle-active) !important;
  box-shadow: 0 0 0 0.2rem var(--secondary-subtle-hover) !important;
}
:host ::ng-deep .p-inputotp-input.p-inputtext.ng-invalid,
:host ::ng-deep .p-inputotp-input.p-inputtext.p-invalid {
  border-color: var(--danger-regular-default) !important;
}
:host ::ng-deep .p-inputotp-input.p-inputtext:disabled {
  background: var(--secondary-subtle-default) !important;
  color: var(--text-label) !important;
  border-color: var(--secondary-regular-default) !important;
  box-shadow: none !important;
}
:host ::ng-deep .p-inputotp-input.p-inputtext:-webkit-autofill,
:host ::ng-deep .p-inputotp-input.p-inputtext:-webkit-autofill:hover,
:host ::ng-deep .p-inputotp-input.p-inputtext:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--text-default) !important;
  caret-color: var(--text-default);
  box-shadow: 0 0 0 48px var(--contrast-inverse) inset !important;
  border: 1px solid var(--secondary-regular-default) !important;
  border-radius: 4px !important;
  transition: background-color 99999s ease-out;
}
.error-item {
  margin: 0;
  color: var(--danger-regular-default);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
/*# sourceMappingURL=pa-input-otp.component.css.map */
